export default "__VITE_ASSET__BVwETsJh__"